<app-access-item>
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/zoom.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header [comingSoon]="true">
    <div>Viewing Controls</div>
  </app-access-item-header>

  <app-access-item-cta>
    <app-switch [smallish]="true">
      <input type="checkbox" id="viewing-controls" [ngModel]="false" [disabled]="true" />
      <label for="viewing-controls"></label>
    </app-switch>
  </app-access-item-cta>
</app-access-item>
